import React, { FC } from 'react';
import styles from './Breadcrumb.module.scss';
import { BreadcrumbNodeType } from './types';
import BreadcrumbNode from './BreadcrumbNode';

type BreadcrumbPath = {
  node: BreadcrumbNodeType;
};

const Breadcrumb: FC<BreadcrumbPath> = ({ node }) => {
  return (
    <div className={styles.breadcrumb}>
      <span>{node.name}</span>
      <BreadcrumbNode node={node.next} />
    </div>
  );
};

export default Breadcrumb;
